import { Routes } from '@angular/router';
import { AppLayout } from '@/layout/components/app.layout';
import { Notfound } from '@/pages/notfound/notfound';
import { LandingLayout } from '@/layout/components/app.landinglayout';
import { AuthLayout } from '@/layout/components/app.authlayout';
import { AuthenticationGuard } from '@/core/guards/authentication.guard';
import { AuthorizationGuard } from '@/core/guards/authorization.guard';
import { LoginComponent } from '@/features/login/login.component';

export const appRoutes: Routes = [
    {
        path: 'login',
        loadChildren: () => import('@/features/login/login.routes').then(m => m.LOGIN_ROUTES)
    },

    {
        path: '',
        component: AppLayout,
        children: [
            //DASHBOARD
            // {
            //     path: '',
            //     loadComponent: () => import('@/pages/dashboards/banking/bankingdashboard').then((c) => c.BankingDashboard),
            //     canActivate: [AuthenticationGuard],
            //     data: {
            //         title: 'Cargos',
            //         roles: ['Admin', 'P_MAX', 'MXL_CARGO_CON']
            //       }
            // },
            // {
            //     path: 'dashboard-banking',
            //     loadComponent: () => import('@/pages/dashboards/banking/bankingdashboard').then((c) => c.BankingDashboard),
            //     canActivate: [AuthenticationGuard],
            //     data: {
            //         title: 'Cargos',
            //         roles: ['Admin', 'P_MAX', 'MXL_CARGO_CON']
            //       }
            // },
            {
                path: '',
                loadComponent: () => import('@/pages/home/dashboard/home-dashboard').then((c) => c.HomeDashboard),
                canActivate: [AuthenticationGuard],
                data: {
                    title: 'Painel de Gestão',
                    //breadcrumb: 'Dashboard de Penalidades',
                    roles: ['Admin', 'P_MAX', 'DASH_HOME_CON']
                }
            },

            {
                path: 'relacao-funcionarios',
                loadChildren: () => import('@/features/funcionario/funcionario.routes').then(m => m.FUNCIONARIO_ROUTES),
                canActivate: [AuthenticationGuard],
            },

            {
                path: 'relacao-usuarios',
                loadChildren: () => import('@/features/controle-acesso/usuario/usuario.routes').then(m => m.USUARIO_ROUTES),
                canActivate: [AuthenticationGuard],
            },

            {
                path: 'consumo-bateria',
                loadChildren: () => import('@/features/consumo-bateria/consumo-bateria.routes').then(m => m.CONSUMO_BATERIA_ROUTES),
                canActivate: [AuthenticationGuard],
            },
            {
                path: 'log-login',
                loadChildren: () => import('@/features/log-login/log-login.routes').then(m => m.LOG_LOGIN_ROUTES),
                canActivate: [AuthenticationGuard],
                data: {
                    title: 'Relatório de Login',
                    //breadcrumb: 'Dashboard de Penalidades',
                    roles: ['Admin', 'P_MAX', 'REL_LOGIN_RESET']
                }
            },
            {
                path: 'log-login-reset',
                loadChildren: () => import('@/features/log-login-reset/log-login-reset.routes').then(m => m.LOG_LOGIN_RESET_ROUTES),
                canActivate: [AuthenticationGuard],
                data: {
                    title: 'Relatório de Reset de Login',
                    //breadcrumb: 'Dashboard de Penalidades',
                    roles: ['Admin', 'P_MAX', 'REL_LOGIN_RESET']
                }

            },
            //IMPORTAÇÃO
            {
                canActivate: [AuthenticationGuard],
                path: 'importacao',
                loadChildren: () => import('@/features/importacao/importacao.routes').then(m => m.IMPORTACAO_ROUTES),
            },
            // OPERAÇÂO
            // {
            //     canActivate: [AuthenticationGuard],
            //     path: 'atividade-list',
            //     loadChildren: () => import('@/features/atividade/atividade/atividade.routes').then(m => m.ATIVIDADE_ROUTES),
            // },

            {
                path: 'relatorio-tempo-visita',
                loadChildren: () => import('@/features/relatorio-tempo-visita/relatorio-tempo-visita.routes').then(m => m.RELATORIO_TEMPO_VISITA_ROUTES),
                canActivate: [AuthenticationGuard],
            },

            {
                path: 'relatorio-tempo-atividade',
                loadChildren: () => import('@/features/relatorio-tempo-atividade/relatorio-tempo-atividade.routes').then(m => m.RELATORIO_TEMPO_ATIVIDADE_ROUTES),
                canActivate: [AuthenticationGuard],
            },
            {
                path: 'estrutura-geografica',
                loadChildren: () => import('@/features/hierarquia/hierarquia.routes').then(m => m.HIERARQUIA_ROUTES),
                canActivate: [AuthenticationGuard],
            },
            {
                canActivate: [AuthenticationGuard],
                path: 'planejamento-escala',
                loadChildren: () => import('@/features/planejamento-escala/planejamento-escala.routes').then(m => m.PLANEJAMENTO_ESCALA_ROUTES),
            },

            // {
            //     path: 'relatorio-tempo-matinal',
            //     loadChildren: () => import('@/features/relatorio-tempo-matinal/relatorio-tempo-matinal.routes').then(m => m.RELATORIO_TEMPO_MATINAL_ROUTES),
            //     canActivate: [AuthenticationGuard],
            // },

            {
                path: 'ponto-invalido',
                loadChildren: () => import('@/features/ponto-invalido/ponto-invalido.routes').then(m => m.PONTO_INVALIDO_ROUTES),
                canActivate: [AuthenticationGuard],
            },

            //MONITORAMENTO
             {
                canActivate: [AuthenticationGuard],
                path: 'monitor',
                loadChildren: () => import('@/features/monitor/monitor.routes').then(m => m.MONITOR_ROUTES),
            },

            {
                path: 'hora-extra-produtiva',
                loadChildren: () => import('@/features/hora-extra-produtiva/hora-extra-produtiva.routes').then(m => m.HORA_EXTRA_PRODUTIVA_ROUTES),
                canActivate: [AuthenticationGuard],
            },
            {
                path: 'hora-extra-notificada',
                loadChildren: () => import('@/features/hora-extra-notificada/hora-extra-notificada.routes').then(m => m.HORA_EXTRA_NOTIFICADA_ROUTES),
                canActivate: [AuthenticationGuard],
            },
            {
                path: 'registros-com-ressalva',
                loadChildren: () => import('@/features/registros-com-ressalva/registros-com-ressalva.routes').then(m => m.REGISTROS_COM_RESSALVA_ROUTES),
                canActivate: [AuthenticationGuard],
            },
            {
                path: 'relatorio-acompanhamento-ponto',
                loadChildren: () => import('@/features/relatorio-acompanhamento-ponto/relatorio-acompanhamento-ponto.routes').then(m => m.RELATORIO_ACOMPANHAMENTO_PONTO_ROUTES),
                canActivate: [AuthenticationGuard],
            },
            {
                path: 'controle-localizacao',
                loadChildren: () => import('@/features/controle-localizacao/controle-localizacao.routes').then(m => m.CONTROLE_LOCALIZACAO_ROUTES),
                canActivate: [AuthenticationGuard],
            },
            {
                path: 'controle-jornada',
                loadChildren: () => import('@/features/controle-jornada/controle-jornada.routes').then(m => m.CONTROLE_JORNADA_ROUTES),
                canActivate: [AuthenticationGuard],
            },
            {
                path: 'relatorio-coordenadas',
                loadChildren: () => import('@/features/relatorio-coordenadas/relatorio-coordenadas.routes').then(m => m.RELATORIO_COORDENADAS_ROUTES),
                canActivate: [AuthenticationGuard],
            },

            {
                path: 'rotina',
                loadChildren: () => import('@/features/controle-acesso/rotina/rotina.routes').then(m => m.ROTINA_ROUTES),
                canActivate: [AuthenticationGuard],
            },
            {
                path: 'perfil',
                loadChildren: () => import('@/features/controle-acesso/perfil/perfil.routes').then(m => m.PERFIL_ROUTES),
                canActivate: [AuthenticationGuard],
            },

            {
                path: 'dashboard-marketing',
                loadComponent: () => import('@/pages/dashboards/marketing/marketingdashboard').then((c) => c.MarketingDashboard),
                data: { breadcrumb: 'Marketing Dashboard' }
            },
            {
                path: 'dashboard-penalidades',
                loadComponent: () => import('@/pages/home/dashboard/home-dashboard').then((c) => c.HomeDashboard),
                canActivate: [AuthenticationGuard],
                //data: { breadcrumb: 'Dashboard' }
            },
            {
                path: 'uikit',
                data: { breadcrumb: 'UI Kit' },
                loadChildren: () => import('@/pages/uikit/uikit.routes')
            },
            {
                path: 'documentation',
                data: { breadcrumb: 'Documentation' },
                loadComponent: () => import('@/pages/documentation/documentation').then((c) => c.Documentation)
            },
            {
                path: 'pages',
                loadChildren: () => import('@/pages/pages.routes'),
                data: { breadcrumb: 'Pages' }
            },
            {
                path: 'apps',
                loadChildren: () => import('@/apps/apps.routes'),
                data: { breadcrumb: 'Apps' }
            },

            {
                path: 'blocks',
                data: { breadcrumb: 'Free Blocks' },
                loadChildren: () => import('@/pages/blocks/blocks.routes')
            },
            {
                path: 'ecommerce',
                loadChildren: () => import('@/pages/ecommerce/ecommerce.routes'),
                data: { breadcrumb: 'E-Commerce' }
            },
            {
                path: 'profile',
                loadChildren: () => import('@/pages/usermanagement/usermanagement.routes')
            }
        ]
    },
    {
        path: 'landing',
        component: LandingLayout,
        children: [
            {
                path: '',
                loadComponent: () => import('@/pages/landing/landingpage').then((c) => c.LandingPage)
            },
            {
                path: 'features',
                loadComponent: () => import('@/pages/landing/featurespage').then((c) => c.FeaturesPage)
            },
            {
                path: 'pricing',
                loadComponent: () => import('@/pages/landing/pricingpage').then((c) => c.PricingPage)
            },
            {
                path: 'contact',
                loadComponent: () => import('@/pages/landing/contactpage').then((c) => c.ContactPage)
            }
        ]
    },


    { path: 'notfound', component: Notfound },
    {
        path: 'auth',
        component: AuthLayout,
        children: [
            {
                path: 'login',
                loadComponent: () => import('@/pages/auth/login').then((c) => c.Login)
            },
            {
                path: 'register',
                loadComponent: () => import('@/pages/auth/register').then((c) => c.Register)
            },
            {
                path: 'verification',
                loadComponent: () => import('@/pages/auth/verification').then((c) => c.Verification)
            },
            {
                path: 'forgot-password',
                loadComponent: () => import('@/pages/auth/forgotpassword').then((c) => c.ForgotPassword)
            },
            {
                path: 'new-password',
                loadComponent: () => import('@/pages/auth/newpassword').then((c) => c.NewPassword)
            },
            {
                path: 'lock-screen',
                loadComponent: () => import('@/pages/auth/lockscreen').then((c) => c.LockScreen)
            },
            {
                path: 'access',
                loadComponent: () => import('@/pages/auth/access').then((c) => c.Access)
            },
            {
                path: 'oops',
                loadComponent: () => import('@/pages/oops/oops').then((c) => c.Oops)
            },
            {
                path: 'error',
                loadComponent: () => import('@/pages/notfound/notfound').then((c) => c.Notfound)
            }
        ]
    },
    { path: '**', redirectTo: '/notfound' }
];

